import PrebuiltBetBuilderAvantgardeImpl from './prebuilt-bet-builder-avantgarde.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltBetBuilderAvantgarde view that renders prebuilt bet builder card with the avantgarde layout.
 *
 * @class PrebuiltBetBuilderAvantgarde
 * @memberof Mojito.Modules
 */

/**
 * PrebuiltBetBuilderAvantgarde prop types.
 *
 * @property {object} event - Event data.
 * @property {object} market - Market data.
 * @property {string|undefined} [promotionText] - Promotion text to be displayed on the card.
 * @property {object} [boostedMarket] - Boosted market data.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 * @property {boolean} [shouldRequestData = true] - Flag indicating whether the part events and markets should be requested from content. If false, then part metadata is resolved from the data already available in a store.
 *
 * @memberof Mojito.Modules.PrebuiltBetBuilderAvantgarde
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    promotionText: PropTypes.string,
    boostedMarket: PropTypes.object,
    onEventClick: PropTypes.func,
    shouldRequestData: PropTypes.bool,
};

const defaultProps = {
    shouldRequestData: true,
};

export default UIView(
    'PrebuiltBetBuilderAvantgarde',
    PrebuiltBetBuilderAvantgardeImpl,
    propTypes,
    defaultProps
);
